import { RouteObject } from 'react-router';
import { ROUTES } from '../../../router/routes';
import { SettingsSection } from '../components/base/sections/SettingsSection';
import {
    aboutSection,
    aircraftSection,
    alertsSection,
    diversionManagerSection,
    externalLinkIntegrationSection,
    filterGroupsSection,
    generalSection,
    monitorAlertSection,
    notesSection,
    viewsSection,
    weatherSection
} from '../components/base/settings-definitions';
import { SettingsCustomEmailAlertingElement } from '../components/custom-elements/SettingsCustomEmailAlertingElement';
import SettingsAircraftEdrOverrides from '../components/sub-pages/aircraft/SettingsAircraftEdrOverrides';
import SettingsAircraftTypeParameters from '../components/sub-pages/aircraft/SettingsAircraftTypeParameters';
import SettingsMyFleetAcidList from '../components/sub-pages/aircraft/SettingsMyFleetAcidList';
import { SettingsFilterGroups } from '../components/sub-pages/filter-groups/SettingsFilterGroups';
import { ClockSettings } from '../components/sub-pages/general/SettingsClocks';
import SettingsAircraftThresholds from '../components/sub-pages/monitor-alert/aircraft/SettingsAircraftThresholds';
import SettingsAircraftThresholdsOptions from '../components/sub-pages/monitor-alert/aircraft/SettingsAircraftThresholdsOptions';
import SettingsAirportThresholdOptions from '../components/sub-pages/monitor-alert/airport/SettingsAirportThresholdOptions';
import SettingsAirportThresholds from '../components/sub-pages/monitor-alert/airport/SettingsAirportThresholds';
import { SettingsNotes } from '../components/sub-pages/notes/SettingsNotes';
import Settings from '../Settings';
import { SETTINGS_ROUTES } from './settings-routes';

export const settingsRoutes: RouteObject[] = [
    {
        path: ROUTES.SETTINGS,
        element: <Settings />,
        children: [
            // { path: '', element: <Navigate to={SETTINGS_ROUTES.general} replace /> },
            { path: SETTINGS_ROUTES.general.index, element: <SettingsSection section={generalSection} /> },
            {
                path: `${SETTINGS_ROUTES.general.index}/${SETTINGS_ROUTES.general.clocks}`,
                element: <ClockSettings />
            },
            { path: SETTINGS_ROUTES.aircraft.index, element: <SettingsSection section={aircraftSection} /> },
            { path: `${SETTINGS_ROUTES.aircraft.index}/${SETTINGS_ROUTES.aircraft.acidList}`, element: <SettingsMyFleetAcidList /> },
            {
                path: `${SETTINGS_ROUTES.aircraft.index}/${SETTINGS_ROUTES.aircraft.typeParams}`,
                element: <SettingsAircraftTypeParameters />
            },
            {
                path: `${SETTINGS_ROUTES.aircraft.index}/${SETTINGS_ROUTES.aircraft.edrOverrides}`,
                element: <SettingsAircraftEdrOverrides />
            },

            { path: SETTINGS_ROUTES.views, element: <SettingsSection section={viewsSection} /> },
            { path: SETTINGS_ROUTES.weather, element: <SettingsSection section={weatherSection} /> },
            { path: SETTINGS_ROUTES.filterGroups.index, element: <SettingsSection section={filterGroupsSection} /> },
            {
                path: `${SETTINGS_ROUTES.filterGroups.index}/${SETTINGS_ROUTES.filterGroups.manage}`,
                element: <SettingsFilterGroups />
            },
            { path: SETTINGS_ROUTES.monitorAlert.index, element: <SettingsSection section={monitorAlertSection} /> },
            {
                path: `${SETTINGS_ROUTES.monitorAlert.index}/${SETTINGS_ROUTES.monitorAlert.aircraftThresholds}`,
                element: <SettingsAircraftThresholds />
            },
            {
                path: `${SETTINGS_ROUTES.monitorAlert.index}/${SETTINGS_ROUTES.monitorAlert.aircraftOptions}`,
                element: <SettingsAircraftThresholdsOptions />
            },
            {
                path: `${SETTINGS_ROUTES.monitorAlert.index}/${SETTINGS_ROUTES.monitorAlert.airportThresholds}`,
                element: <SettingsAirportThresholds />
            },
            {
                path: `${SETTINGS_ROUTES.monitorAlert.index}/${SETTINGS_ROUTES.monitorAlert.airportOptions}`,
                element: <SettingsAirportThresholdOptions />
            },

            { path: SETTINGS_ROUTES.externalLinkIntegration, element: <SettingsSection section={externalLinkIntegrationSection} /> },
            { path: SETTINGS_ROUTES.notes.index, element: <SettingsSection section={notesSection} /> },
            { path: `${SETTINGS_ROUTES.notes.index}/${SETTINGS_ROUTES.notes.manage}`, element: <SettingsNotes /> },
            { path: SETTINGS_ROUTES.alerts.index, element: <SettingsSection section={alertsSection} /> },
            { path: `${SETTINGS_ROUTES.alerts.index}/${SETTINGS_ROUTES.alerts.emails}`, element: <SettingsCustomEmailAlertingElement /> },
            { path: SETTINGS_ROUTES.diversionManager, element: <SettingsSection section={diversionManagerSection} /> },
            { path: SETTINGS_ROUTES.about, element: <SettingsSection section={aboutSection} /> }
        ]
    }
];
